import React from "react";
import "./Button.css";

/**
 * Reusable Button component
 *
 * Props:
 * - variant: 'primary' | 'secondary' | 'destructive' | 'ghost'
 * - size: 'sm' | 'md' | 'lg'
 * - fullWidth: boolean
 * - loading: boolean
 * - disabled: boolean
 * - leftIcon, rightIcon: ReactNode (optional icons)
 * - type: 'button' | 'submit' | 'reset'
 * - onClick: () => void
 * - className: string (extra classes)
 */
const Button = React.forwardRef(
  (
    {
      children,
      variant = "primary",
      size = "md",
      fullWidth = false,
      loading = false,
      disabled = false,
      leftIcon,
      rightIcon,
      type = "button",
      onClick,
      className = "",
      ...rest
    },
    ref
  ) => {
    const classes = [
      "owly-btn",
      `owly-btn--${variant}`,
      `owly-btn--${size}`,
      fullWidth ? "owly-btn--block" : "",
      loading ? "owly-btn--loading" : "",
      className,
    ]
      .filter(Boolean)
      .join(" ");

    return (
      <button
        ref={ref}
        type={type}
        className={classes}
        onClick={onClick}
        disabled={disabled || loading}
        {...rest}
      >
        {leftIcon ? <span className="owly-btn__icon owly-btn__icon--left">{leftIcon}</span> : null}
        <span className="owly-btn__label">{children}</span>
        {rightIcon ? (
          <span className="owly-btn__icon owly-btn__icon--right">{rightIcon}</span>
        ) : null}
      </button>
    );
  }
);

Button.displayName = "Button";

export default Button;
